import React from "react";
import {connect} from "react-redux";
import {
  translate,
  Datagrid,
  TextField,
  DateField,
  FileField,
  refreshView as refreshViewAction
} from "admin-on-rest";
import { Card, CardText } from 'material-ui/Card';
import FileInput from "../../../components/CRM/UploadFileInput";
import FileInputPreview from '../../../components/CRM/UploadFileInputPreview';
import DeleteButton from '../../../components/CRM/SuppressionListDeleteButton';
import Title from "../../../components/CRM/Title";
import { CardTitle } from 'material-ui/Card';
import {Toolbar, ToolbarGroup} from "material-ui/Toolbar";
import ContentSave from 'material-ui/svg-icons/content/save';
import FlatButton from 'material-ui/FlatButton';
import Avatar from "material-ui/Avatar";
import {listStyle} from "./style";
import {BMTheme} from "../../../BMTheme";


const styles = {
  noResults: { padding: 20, marginBottom: 20 },
  header: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      top: '-98px',
      zIndex: '1200',
      marginLeft: '20px'
  },
  filter: {
      marginTop: '-85px',
      backgroundColor: `${BMTheme.menuItem.selectedTextColor}`,
      marginBottom: '15px',
      borderRadius: '2px',
      boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
  dropzones: {
    float: 'left',
    width: '48%',
    margin: '1%'
  },
  uploadButton: {
    backgroundColor: "#3EB9D0",
    color: "#fff"
  },
  clearFloatContainer: {
    clear: "both"
  },
  removeStyle: {
    display: "inline-block"
  },
  preview: {
      float: 'left',
  }
};

const FullNameField = ({record = {}}) => (
  <div style={listStyle.textFieldContainer}>
    <Avatar color={BMTheme.customerAvatar.color} backgroundColor={BMTheme.customerAvatar.backgroundColor} style={listStyle.avatarSyle}>
      {record.first_name.charAt(0)}
      {record.last_name.charAt(0)}
    </Avatar>

    <span style={listStyle.textFieldStyle}>
      {record.first_name} {record.last_name}
    </span>
  </div>
);

class SuppressionsDataListBase extends React.Component {
  state = {
    selectedRow: [],
    selectedAll: "",
    selectedIds: [],
    activeEmailUpload: true,
    activePhoneUpload: true,
    droppedFile: null,
    uploadType: null,
    suppressionsList: null,
    suppressionsListIds: null,
    showNoResults: false
  };

  fileDrop = async (file, type) => {
    this.setState({ droppedFile: file[0], uploadType: type, showNoResults: false, suppressionsList: null, suppressionsListIds: null });
    if(type === 'email') this.setState({ activePhoneUpload: false });
    if(type === 'phone') this.setState({ activeEmailUpload: false });
  }

  uploadFile = () => {
    const { droppedFile, uploadType } = this.state;
    let reader = new FileReader();
    reader.readAsDataURL(droppedFile.rawFile);
    reader.onload = async (file) => {      
      try {
        const token = localStorage.getItem("token");
        const data = file.target.result;
        
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/suppressions?type=${uploadType}`,
          {
            method: "POST",
            headers: {
              "Authorization": "Bearer " + token,
              "X-Source": "crm"
            },
            body: data
          }
        );
        response = await response.json();
        
        let recordData = {};
        const ids = response.data.map(customer => {
          recordData[customer.id] = customer.attributes;
          recordData[customer.id].id = customer.id;
          return customer.id;
        });     
        
        this.setState({
          suppressionsList: recordData,
          suppressionsListIds: ids
        });
        if(!ids.length){
          this.setState({ showNoResults: true });
          this.onRemove();
        }
        this.props.record.data = recordData;        
        this.props.record.list.ids = ids;
        this.props.record.list.total = ids.length;
      } catch (e) {
        console.log("error", e);
      }
    }

  }

  onRemove = () => {    
    this.setState({ droppedFile: null });
    this.setState({ activePhoneUpload: true, activeEmailUpload: true });
  };

  render() {
    const props = {...this.props};
    const {translate} = props;
    const { suppressionsList, suppressionsListIds, showNoResults } = this.state;

    const titleElement = (
      <Title title="resources.suppressions.name" defaultTitle="resources.suppressions.name" />
    );

    const emailFileUploadElement = (
      this.state.activeEmailUpload && 
      <div style={styles.dropzones}>
        <FileInput
          {...props}
          source="suppressions"
          label={translate("resources.suppressions.inputs.uploadEmailList")}
          accept="text/plain"
          style={styles.dropzones}
          onChange={(file)=>{
            this.fileDrop(file, 'email');
          }}
        ></FileInput>          
      </div>
    );
    const phoneFileUploadElement = (
      this.state.activePhoneUpload && 
      <div style={styles.dropzones}>
        <FileInput
          {...props}
          source="suppressions"
          label={translate("resources.suppressions.inputs.uploadPhoneList")}
          accept="text/plain"
          style={styles.dropzones}
          onChange={(file)=>{
            this.fileDrop(file, 'phone');
          }}
        ></FileInput>
      </div>
    );
    
    return !suppressionsList ? (
      <div className="upload-page" >
        <div style={styles.header}>
          <CardTitle title={titleElement} className="title" />
        </div>
        {emailFileUploadElement}
        {phoneFileUploadElement}
        <div style={styles.clearFloatContainer} />
        {this.state.droppedFile && <div className="previews">
          <FileInputPreview
              file={this.state.droppedFile.rawFile}
              onRemove={this.onRemove}
              removeStyle={styles.removeStyle}
          >
            <FileField source="src" title="title" />
          </FileInputPreview>
        </div>}
        <div style={styles.clearFloatContainer} />
        <Toolbar style={{ justifyContent: "flex-end" }}>
          <ToolbarGroup>
            <FlatButton
              label={translate("resources.suppressions.inputs.uploadButton")}
              icon={<ContentSave />}
              primary
              style={styles.uploadButton}
              onClick={this.uploadFile}
              disabled={!this.state.droppedFile}
            />
          </ToolbarGroup>						
        </Toolbar>
      </div>
    ) : (
      <div className="list-page">
        <Card>
          {suppressionsListIds.length > 0 &&
            <Datagrid
              options={{
                multiSelectable: false,
                selectable: false,
                displaySelectAll: false,
                // onRowSelection: this.handleRowSelection
              }}
              headerOptions={{
                displaySelectAll: false,
                adjustForCheckbox: false
              }}
              bodyOptions={{
                displayRowCheckbox: false,
                deselectOnClickaway: false,
                showRowHover: true
              }}
              rowOptions={{
                selectable: false
              }}
              data={suppressionsList}
              ids={suppressionsListIds}
              resource="suppressions"
              currentSort={
                {field: "first_name",
                order: "ASC"}
              }
            >
              <FullNameField
                label="resources.customers.fields.customer"
                source="first_name,last_name"
              />
              <TextField label="resources.customers.fields.email" source="email" />
              <TextField label="resources.customers.fields.phone" source="phone" />
              <DateField
                label="resources.customers.fields.createdAt"
                source="created_at"
              />
              <DateField
                label="resources.customers.fields.updatedAt"
                source="updated_at"
              />
              
              <DeleteButton customerBaseUrl="customers" basePath="customers" />

            </Datagrid>
          }
          {(!suppressionsListIds.length && showNoResults) && (
            <div>
              <CardText style={styles.noResults}>
                  {translate(
                      'aor.navigation.no_more_results',
                      {
                          page: 1,
                      }
                  )}
              </CardText>
              <div stlye={styles.noResults}>
                {emailFileUploadElement}
                {phoneFileUploadElement}
              </div>
            </div>
          )}
        </Card>
        
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource]
  };
};

const SuppressionsDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(SuppressionsDataListBase);

export default translate(SuppressionsDataList);



// WEBPACK FOOTER //
// ./src/containers/CRM/Suppressions/SuppressionsDataList.js